
import React , {Component , Fragment} from 'react'
import DropItemContainerUI from '../../ddTxtImg/ui/DropItemContainerUI'
import SortStoryDropItemUI from './SortStoryDropItemUI'

class SortStoryDropItemContainerUI extends DropItemContainerUI{

    constructor(){
        super();
    }

    getDropItemList=()=>{

        let { activity, quizViewer } = this.props
        let { dropItemList } = activity.dropItemContainer

        return(
            <Fragment>
                    {
                        dropItemList.map((dropItem, index) => {
                            return (
                                <SortStoryDropItemUI key={index}
                                    dropItem={dropItem}
                                    activity={activity}
                                    quizViewer={quizViewer}
                                />
                            )

                        })
                    }
            </Fragment>
        )
    }

}

export default SortStoryDropItemContainerUI